import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'utils/translation';
import { Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import addFileImage from 'assets/images/add-file.svg';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: theme.spacing(80),
    margin: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
  },
  image: {
    maxWidth: theme.spacing(30),
  },
  title: {
    margin: theme.spacing(2, 0),
  },
  small: {
    '& $image': {
      maxHeight: '100px',
    },

    '& $title': {
      fontSize: '1em',
    },
  },
}));

type Size = 'small';

const EmptyDir: React.FC<{ size?: Size }> = ({ size }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, size && classes[size])}>
      <img className={classes.image} alt="" src={addFileImage} />
      <Typography className={classes.title} variant="h3">
        {t('No files or folders have been uploaded yet')}
      </Typography>
    </div>
  );
};

export { EmptyDir };
